var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigWhiteBgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 8.58819C15.225 7.50417 16.775 7.50417 17.3334 8.58819L17.7147 9.32819C18.0503 9.97956 18.8073 10.2931 19.5052 10.0699L20.2981 9.81618C21.4595 9.44457 22.5554 10.5405 22.1838 11.7019L21.9301 12.4948C21.7069 13.1927 22.0204 13.9497 22.6718 14.2853L23.4118 14.6666C24.4958 15.225 24.4958 16.775 23.4118 17.3334L22.6718 17.7147C22.0204 18.0503 21.7069 18.8073 21.9301 19.5052L22.1838 20.2981C22.5554 21.4595 21.4595 22.5554 20.2981 22.1838L19.5052 21.9301C18.8073 21.7069 18.0503 22.0204 17.7147 22.6718L17.3334 23.4118C16.775 24.4958 15.225 24.4958 14.6666 23.4118L14.2853 22.6718C13.9497 22.0204 13.1927 21.7069 12.4948 21.9301L11.7019 22.1838C10.5405 22.5554 9.44457 21.4595 9.81618 20.2981L10.0699 19.5052C10.2931 18.8073 9.97956 18.0503 9.32819 17.7147L8.58819 17.3334C7.50417 16.775 7.50417 15.225 8.58819 14.6666L9.32819 14.2853C9.97956 13.9497 10.2931 13.1927 10.0699 12.4948L9.81618 11.7019C9.44457 10.5405 10.5405 9.44457 11.7019 9.81618L12.4948 10.0699C13.1927 10.2931 13.9497 9.97956 14.2853 9.32819L14.6666 8.58819Z",
    fill: "#5062F0",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9997,
    cy: 16,
    r: 2.85714,
    fill: "#5062F0",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigWhiteBgBlue);
export default __webpack_public_path__ + "static/media/configWhiteBgBlue.24df25ee3c3672067dacde0defffb6be.svg";
export { ForwardRef as ReactComponent };